import React from "react";
import { Heading } from "rsuite";
import {
    IWorkflowWithData,
    IWorkflowStep,
} from "store/workflows/workflows-types";

interface Props {
    title: string;
    workflow: IWorkflowWithData<IWorkflowStep, any>;
}

const Header: React.FC<Props> = ({ title, workflow }: Props) => {
    return workflow ? <Heading level={1}>{title}</Heading> : <></>;
};

export default Header;
